/**
 * Brand mark for "deployd" — renders lowercase wordmark + a green dot that
 * behaves like a full stop. The dot is sized in em units so it always scales
 * proportionally with the surrounding text (inline body, hero h1, footer, etc).
 *
 * Props:
 *  - pulsing: if true, dot has a soft pulsing halo (use for hero only).
 *  - className: applied to the outer span.
 *  - size: kept for API compatibility — does NOT affect dot size (em-based).
 */
export default function BrandMark({ className = "", pulsing = false, size }) {
  // Suppress unused-var lint in callers; size is intentionally accepted but ignored
  void size;

  const dotStyle = {
    width: "0.22em",
    height: "0.22em",
    marginLeft: "0.06em",
    marginBottom: "0.02em",
    backgroundColor: "#00D752",
    borderRadius: "9999px",
    display: "inline-block",
    verticalAlign: "baseline",
    boxShadow: pulsing ? undefined : "0 0 0.35em rgba(0,215,82,0.5)",
  };

  return (
    <span
      data-testid="brand-deployd"
      className={`inline-flex items-baseline whitespace-nowrap ${className}`}
    >
      deployd
      <span
        aria-hidden
        className={pulsing ? "status-dot" : ""}
        style={dotStyle}
      />
    </span>
  );
}
